/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_SubInputs */

const tr_landing_finalcta_sub = /** @type {(inputs: Landing_Finalcta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk gün kurulum, ilk hafta otomasyon, ilk ay tam kontrol. Dakikalar içinde başlayın, ilk satışınıza hazır olun.`)
};

const en_landing_finalcta_sub = /** @type {(inputs: Landing_Finalcta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup on day one, automation in week one, full control in month one. Start in minutes and be ready for your first sale.`)
};

const de_landing_finalcta_sub = /** @type {(inputs: Landing_Finalcta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtung am ersten Tag, Automatisierung in der ersten Woche, volle Kontrolle im ersten Monat. Starten Sie in wenigen Minuten und seien Sie bereit für Ihren ersten Verkauf.`)
};

const ru_landing_finalcta_sub = /** @type {(inputs: Landing_Finalcta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка в первый день, автоматизация в первую неделю, полный контроль в первый месяц. Начните за несколько минут и будьте готовы к первой продаже.`)
};

/**
* | output |
* | --- |
* | "Setup on day one, automation in week one, full control in month one. Start in minutes and be ready for your first sale." |
*
* @param {Landing_Finalcta_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_sub = /** @type {((inputs?: Landing_Finalcta_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_sub(inputs)
	if (locale === "de") return de_landing_finalcta_sub(inputs)
	if (locale === "ru") return ru_landing_finalcta_sub(inputs)
	return tr_landing_finalcta_sub(inputs)
});